/* Sjednoceny price-format fix (drive inline v snippets/price.liquid a price-single.liquid,
   emitovany pri kazdem renderu snippetu = az stovky MutationObserveru na kolekci).
   Jedna instance, jeden debounced observer na document.body. */
(function () {
  if (window.__yerbPriceFormat) return;
  window.__yerbPriceFormat = true;

  var CONTAINER_SELECTOR = '.price__container, .product-davky-badge';
  var PRICE_SELECTOR = '.price-item, .price__regular .price-item, .price__sale .price-item, .product-davky-badge .badge';

  function getCurrencyCode() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.iso_code) {
      return window.Shopify.currency.iso_code;
    }
    var currencyEl = document.querySelector('[data-currency], [data-shop-currency]');
    if (currencyEl) {
      return currencyEl.dataset.currency || currencyEl.dataset.shopCurrency;
    }
    return 'CZK';
  }

  function formatPrice(priceText, currencyCode) {
    if (!priceText) return priceText;

    var cleanText = priceText.toString().trim();
    var numberMatch = cleanText.match(/[\d,]+\.?\d*/);
    if (!numberMatch) return priceText;

    var numberStr = numberMatch[0].replace(/,/g, '');
    var number = parseFloat(numberStr);

    if (isNaN(number)) return priceText;

    var formatted;
    var upperCurrency = (currencyCode || '').toUpperCase();

    if (upperCurrency === 'CZK') {
      formatted = Math.round(number).toString();
      if (cleanText.indexOf('Kč') !== -1 || cleanText.indexOf('CZK') !== -1) {
        formatted += ' Kč';
      }
    } else {
      formatted = number.toFixed(2).replace(/\.?0+$/, '');
      var currencyMatch = cleanText.match(/([A-Z]{3}|[^\d\s,\.]+)/);
      if (currencyMatch && formatted.indexOf(currencyMatch[0]) === -1) {
        formatted += ' ' + currencyMatch[0];
      }
    }

    return formatted;
  }

  function fixPriceElement(element) {
    if (!element) return;

    var currencyCode = getCurrencyCode();
    var priceElements = element.querySelectorAll(PRICE_SELECTOR);

    priceElements.forEach(function (el) {
      if (el.dataset.priceFormatted === 'true') return;

      var text = el.textContent.trim();
      if (text.match(/\d+\.\d{3,}/)) {
        var formatted = formatPrice(text, currencyCode);
        if (formatted !== text) {
          el.textContent = formatted;
          el.dataset.priceFormatted = 'true';
        }
      }
    });
  }

  function fixAll() {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach(fixPriceElement);
  }

  var scheduled = false;
  function scheduleFix() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      fixAll();
    });
  }

  function start() {
    fixAll();
    setTimeout(fixAll, 100);
    new MutationObserver(scheduleFix).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
